/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { rangeDependencies } from './dependenciesRange.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createRowTransform } from '../../factoriesAny.js';
export var rowTransformDependencies = {
  IndexDependencies: IndexDependencies,
  matrixDependencies: matrixDependencies,
  rangeDependencies: rangeDependencies,
  typedDependencies: typedDependencies,
  createRowTransform: createRowTransform
};